export default __webpack_public_path__ + "static/media/mySky.bb7e6b26.png";